import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'
import classNames from 'classnames'

import PersistentModal from './persistent-modal'
import Typography from '../typography'
import Icon from '../icon'

import Alert from '../icon/alert-triangle.svg'

const getMessage = ({ missingLocation, invalidIdCard }) => {
    if (missingLocation && invalidIdCard) {
        return 'para seguir usando la plataforma necesitamos que completes tu ubicación y registres un número de DPI válido en tu perfil.'
    }

    if (invalidIdCard) {
        return 'para seguir usando la plataforma necesitamos que registres un número de DPI válido en tu perfil.'
    }

    return 'para seguir usando la plataforma necesitamos que completes tu país, departamento y municipio en tu perfil.'
}

const ProfileModal = ({ open, onClose, username, missingLocation, invalidIdCard }) => {
    const message = getMessage({ missingLocation, invalidIdCard })

    return (
        <PersistentModal open={open} onClose={onClose}>
            <div
                className={
                    classNames([
                        'w-screen',
                        'p-6',
                        'md:p-8',
                        'bg-white'
                    ])
                }
                style={{
                    maxWidth: '480px'
                }}>
                <div className="flex items-start mb-4">
                    <Icon
                        svg={Alert}
                        className="text-yellow-500 mr-4"
                        width={24}
                        height={24}
                    />
                    <Typography
                        size="four"
                        weight="bold"
                        className="text-green-600">
                        Actualiza tus datos
                    </Typography>
                </div>

                <Typography
                    size="three"
                    weight="regular"
                    className="mb-6">
                    {username ? `Hola ${username}, ` : 'Hola, '}{message}
                </Typography>

                <div className="flex justify-end">
                    <Link href="/perfil">
                        <a className="bg-green-600 text-white px-8 py-3 rounded-full hover:bg-green-700 transition-colors">
                            Actualizar mis datos
                        </a>
                    </Link>
                </div>
            </div>
        </PersistentModal>
    )
}

ProfileModal.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    username: PropTypes.string,
    missingLocation: PropTypes.bool,
    invalidIdCard: PropTypes.bool
}

export default ProfileModal
